import { Avatar } from "antd";

import { User } from "@app/models/User.ts";
import { colors } from "@app/theme.ts";

interface CmtUserAvatarProps {
  user: Pick<User, "firstName" | "lastName" | "avatarUrl" | "isActive">;
  size: number;
}

const initials = (firstName: string, lastName: string) =>
  `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

export const CmtUserAvatar = ({ user, size }: CmtUserAvatarProps) => (
  <Avatar
    size={size}
    src={user.avatarUrl || undefined}
    style={{
      backgroundColor: colors["navy-3"],
      fontSize: size / 2.6,
      fontWeight: 700,
      flexShrink: 0,
      filter: user.isActive ? undefined : "grayscale(1)",
    }}
  >
    {initials(user.firstName, user.lastName)}
  </Avatar>
);
